<div class="flex flex-col gap-6 max-w-[700px]" data-testid="mdr-information-page">
  <div class="mt-2 h-10 flex flex-col justify-center">
    <h1 class="headline-medium text-primary" data-testid="mdr-title">{{ 'MDR information' | translate }}</h1>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="mdr-info-columns">
    <section class="flex flex-col gap-1" data-testid="mdr-product">
      <h2 class="title-medium text-primary font-medium" data-testid="mdr-product-title">{{ 'Product' | translate }}</h2>
      <p class="body-medium text-on-surface" data-testid="mdr-device-name">
        <span class="font-bold">{{ 'Device name' | translate }}</span> {{ deviceName }}
      </p>
      <p class="body-medium text-on-surface" data-testid="mdr-app-version">
        <span class="font-bold">{{ 'App version' | translate }}</span> {{ appVersion }}
      </p>
      <p class="body-medium text-on-surface" data-testid="mdr-release-date">
        <span class="font-bold">{{ 'Build date' | translate }}</span> {{ releaseDate }}
      </p>
    </section>

    @if (manufacturerAddress) {
      <section class="flex flex-col gap-1" data-testid="mdr-manufacturer">
        <h2 class="title-medium text-primary font-medium" data-testid="mdr-manufacturer-title">{{ 'Manufacturer' | translate }}</h2>
        <p class="body-medium text-on-surface font-bold" data-testid="mdr-responsible-person-label">{{ 'UK responsible person' | translate }}</p>
        <p class="body-medium text-on-surface" data-testid="mdr-manufacturer-address" [innerHTML]="providerName + ' &middot; ' + manufacturerAddress.address"></p>
      </section>
    }
  </div>

  <div class="flex items-center gap-3 py-3 border-t border-b border-outline-variant" data-testid="mdr-certifications">
    <span class="title-small text-on-surface" data-testid="mdr-certifications-label">{{ 'Certification' | translate }}</span>
    <img src="assets/UKCA_filled.svg" alt="UKCA Certification" class="h-8 w-8" data-testid="mdr-ukca-icon" />
  </div>

  @for (block of blocks; track block.title; let blockIdx = $index) {
    <div class="mdr-block" [attr.data-testid]="'mdr-block-' + blockIdx">
      <div class="mdr-block-header" [attr.data-testid]="'mdr-block-header-' + blockIdx">
        <div class="flex items-center gap-2">
          <mat-icon class="text-on-surface-variant">{{ block.icon }}</mat-icon>
          <span class="title-medium text-on-surface font-medium">{{ block.title }}</span>
        </div>
        <button mat-button class="text-primary !text-sm !min-w-0 !px-2" (click)="toggleBlock(blockIdx)" [attr.data-testid]="'mdr-block-expand-' + blockIdx">
          @if (block.expanded) {
            {{ 'Collapse all' | translate }}
          }
          @if (!block.expanded) {
            {{ 'Expand all' | translate }}
          }
        </button>
      </div>

      <mat-accordion class="mdr-accordion" multi [attr.data-testid]="'mdr-accordion-' + blockIdx">
        @for (section of block.sections; track section.title; let i = $index) {
          <mat-expansion-panel [(expanded)]="section.expanded" (opened)="syncBlockExpanded(blockIdx)" (closed)="syncBlockExpanded(blockIdx)" [attr.data-testid]="'mdr-accordion-panel-' + blockIdx + '-' + i">
            <mat-expansion-panel-header [attr.data-testid]="'mdr-accordion-header-' + blockIdx + '-' + i">
              <div class="accordion-header-content">
                <span class="accordion-title" [class.accordion-title--bold]="section.bold" [attr.data-testid]="'mdr-accordion-title-' + blockIdx + '-' + i">{{ section.title }}</span>
                <span class="accordion-preview" [innerHTML]="section.content" [attr.data-testid]="'mdr-accordion-preview-' + blockIdx + '-' + i"></span>
              </div>
            </mat-expansion-panel-header>

            <div class="flex flex-col gap-3" [attr.data-testid]="'mdr-accordion-content-' + blockIdx + '-' + i">
              <p class="body-medium text-on-surface-variant" [innerHTML]="section.content"></p>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </div>
  }
</div>
